@if (!showOnlyRouterOutLetPage) {
  <div class="col-md-12 row clear-all flow-content">
    @if (enableHeader) {
      <app-header></app-header>
    }
    <div class="container m-auto">
      <div class="top-container">
        @if (enableBreadCrumbFeature) {
          <div class="breadcrumb-container flex-20">
            <app-breadcrumb></app-breadcrumb>
          </div>
        }
        <!-- {{enableBreadCrumbFeature}} {{hideBreadcrumb}} //gives false true -->
        @if (enableBreadCrumbFeature  || hideBreadcrumb) {
          <div class="disp-none">
            <app-breadcrumb></app-breadcrumb>
          </div>
        }
        <div [ngClass]="enableBreadCrumbFeature ? 'content-container flex-80' : 'content-container' ">
          <!-- class="content-container"  -->
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    @if (enableFooter) {
      <app-footer></app-footer>
    }
  </div>
}
@if (showOnlyRouterOutLetPage) {
  <div>
    <router-outlet></router-outlet>
  </div>
}